import {
  KAKAO_REDIRECT_URL,
  GOOGLE_CLIENT_ID,
  GOOGLE_REDIRECT_URL,
} from '@src/constants/constant';
import { useCallback } from 'react';

export const useKakaoLogin = () => {
  const func = useCallback(() => {
    window.Kakao.Auth.authorize({
      redirectUri: KAKAO_REDIRECT_URL,
    });
  }, []);

  return func;
};

export const useGoogleLogin = () => {
  const func = useCallback(() => {
    const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${GOOGLE_CLIENT_ID}&redirect_uri=${GOOGLE_REDIRECT_URL}&response_type=code&scope=email%20profile`;
    window.location.href = googleAuthUrl;
  }, []);

  return func;
};
